import { Icon, Text } from '@/ui'
import { faArrowDown, faArrowUp } from '@fortawesome/pro-light-svg-icons'
import { TextColors, TypographyStyles } from '@/styles'

export const DifferenceArrow = ({
  isUpward,
  textStyle,
  text,
}: {
  isUpward: boolean
  textStyle: TypographyStyles
  text: string
}) => (
  <>
    <Icon
      icon={!isUpward ? faArrowDown : faArrowUp}
      color={!isUpward ? 'text-red-200' : 'text-green-100'}
    />
    <Text
      variant={textStyle}
      color={!isUpward ? TextColors.RED : TextColors.GREEN}
    >
      {text}
    </Text>
  </>
)
